import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { IssuedItemRow } from "@/component/ItemDispositionMatrix";
import { UserOption } from "@/component/UserSelectAdd";
import { defaultPrintedAtFormatter } from "./exportInventoryResultToPdf";

export async function exportMankoReportToExcel(
  user: UserOption,
  userNamePrinted: string,
  rows: IssuedItemRow[],
  opts?: {
    sheetName?: string;
    fileName?: string;
    title?: string;

    logoBase64?: string;
    logoExt?: "png" | "jpeg";
    printedAt?: Date;
    printedAtFormatter?: (d: Date) => string;
  }
) {
  const {
    sheetName = "Manko",
    fileName = "Manko.xlsx",
    title = "Manko",
    logoBase64,
    logoExt = "png",
    printedAt = new Date(),
    printedAtFormatter = defaultPrintedAtFormatter,
  } = opts ?? {};

  console.log("Manko10");
  console.log(rows);

  const manko = rows
    .map((r) => ({
      label: r.label,
      qty: Number((r.values as any)?.notReturnedManko ?? 0),
    }))
    .filter((x) => x.qty > 0);

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(sheetName);

  ws.columns = [
    { key: "label", width: 60, style: { alignment: { horizontal: "left", vertical: "middle" } } }, // A
    { key: "qty", width: 14, style: { alignment: { horizontal: "right", vertical: "middle" } } }, // B
    { key: "meta2", width: 26, style: { alignment: { horizontal: "right", vertical: "middle" } } }, // C
    { key: "h4", width: 14 },
    { key: "h5", width: 18 },
    { key: "h6", width: 18 },
  ];

  ws.getRow(1).height = 28;

  const titleCell = ws.getCell(1, 1); // A1
  titleCell.value = title;
  titleCell.font = { size: 14, bold: true };
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "left",
    indent: 7,
  };

  const printedText = printedAtFormatter(printedAt);
  const metaText = userNamePrinted ? `${userNamePrinted}, ${printedText}` : printedText;

  ws.getCell(1, 2).value = metaText; // B1
  ws.getCell(1, 2).font = { size: 10 };
  ws.getCell(1, 2).alignment = { vertical: "middle", horizontal: "right" };
  ws.mergeCells(1, 2, 1, 3);

  if (logoBase64) {
    const imageId = wb.addImage({
      base64: logoBase64,
      extension: logoExt,
    });

    ws.addImage(imageId, {
      tl: { col: 0, row: 0 }, 
      ext: { width: 68, height: 37 },
    });
  }

  ws.getRow(2).height = 18;
  ws.getCell(2, 1).value = user.label ?? "";
  ws.getCell(2, 1).font = { size: 12, bold: true };
  ws.getCell(2, 1).alignment = { vertical: "middle", horizontal: "left" };
  ws.mergeCells(2, 1, 2, 3);

  if (user.subtitle?.trim()) {
    ws.getRow(3).height = 16;
    ws.getCell(3, 1).value = user.subtitle;
    ws.getCell(3, 1).font = { size: 10 };
    ws.getCell(3, 1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    ws.mergeCells(3, 1, 3, 3);
  }

  const startHeaderRow = user.subtitle?.trim() ? 5 : 4;

  const headerRow = ws.getRow(startHeaderRow);
  headerRow.getCell(1).value = "Položka";
  headerRow.getCell(2).value = "Počet";
  headerRow.font = { bold: true };
  headerRow.height = 18;
  headerRow.alignment = { vertical: "middle" };

  [1, 2].forEach((col) => {
    const cell = headerRow.getCell(col);
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEAEAEA" },
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FF999999" } },
      left: { style: "thin", color: { argb: "FF999999" } },
      bottom: { style: "thin", color: { argb: "FF999999" } },
      right: { style: "thin", color: { argb: "FF999999" } },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: col === 2 ? "right" : "left",
    };
  });

  ws.views = [{ state: "frozen", ySplit: startHeaderRow }];

  if (manko.length === 0) {
    const r = ws.getRow(startHeaderRow + 1);
    r.getCell(1).value = "Žádná pohledávka.";
    r.getCell(2).value = "";
    ws.mergeCells(startHeaderRow + 1, 1, startHeaderRow + 1, 2);
    r.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
  } else {
    manko.forEach((it, idx) => {
      const r = ws.addRow([it.label, it.qty]);

      if (idx % 2 === 1) {
        [1, 2].forEach((c) => {
          r.getCell(c).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF7F7F7" },
          };
        });
      }

      [1, 2].forEach((c) => {
        r.getCell(c).border = {
          top: { style: "thin", color: { argb: "FFDDDDDD" } },
          left: { style: "thin", color: { argb: "FFDDDDDD" } },
          bottom: { style: "thin", color: { argb: "FFDDDDDD" } },
          right: { style: "thin", color: { argb: "FFDDDDDD" } },
        };
      });

      r.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      r.getCell(2).alignment = { vertical: "middle", horizontal: "right" };
    });
  }

  ws.autoFilter = {
    from: { row: startHeaderRow, column: 1 },
    to: { row: startHeaderRow, column: 2 },
  };

  const buf = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    fileName
  );
}